module.exports = __webpack_public_path__ + "assets/img/11_470.d41032aa.jpg";